import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import constants from '../constants/formModalConstants';
import contentChangeActionFactory from './factories/contentChangeActionFactory';
import changeActionFactory from './factories/changeActionFactory';
import uploadActionFactory from './factories/uploadActionFactory';
import entityActionFactory from './factories/entityActionFactory';
const changeActions = changeActionFactory('formModal', 'forms');
const entityActions = entityActionFactory('formModal', 'forms');
const contentChangeActions = contentChangeActionFactory('formModal', 'forms', true, 'Photo');
const uploadActions = uploadActionFactory('formModal', 'forms');
const open = payload => ({
  type: constants.OPEN,
  payload
});
const close = () => ({
  type: constants.CLOSE
});
const setEditorCacheValue = (name, value) => ({
  type: constants.SET_EDITOR_CACHE_VALUE,
  name,
  value
});
const setEditorCacheValueFromDeferred = (id, content) => ({
  type: constants.SET_EDITOR_CACHE_VALUE_FROM_DEFERRED,
  id,
  content
});
export default _objectSpread(_objectSpread(_objectSpread(_objectSpread({
  change: contentChangeActions.change,
  getEntityRoute: contentChangeActions.getEntityRoute,
  open,
  close,
  setEditorCacheValue,
  setEditorCacheValueFromDeferred
}, entityActions), uploadActions), changeActions), contentChangeActions);